import { Handle, Position } from "reactflow";
import { AiOutlinePlus } from "react-icons/ai";
import { TbFileSettings } from "react-icons/tb";
const StartNode = ({
  title,
  onClick,
  isEditing,
  openProgressSettingsModal,
  translate,
}) => {
  return (
    <div className="start-node text-center d-flex align-items-center">
      <div>
        <p className="font-weight-bold mb-0 fs-5 ms-3">
          {translate("design_approval_process.nodes.beginning")}
        </p>
      </div>
      <div className="ms-auto">
        <p className="font-weight-bold mb-0 fs-5 me-3">{title || ""}</p>
      </div>
      {isEditing && (
        <TbFileSettings
          className="fs-2 me-3 cursor--pointer"
          onClick={openProgressSettingsModal}
        />
      )}
      <Handle type="source" position={Position.Bottom} id={"SourceBottom0"} />
      {isEditing && (
        <span className="add-node p-2 rounded-circle" onClick={onClick}>
          <AiOutlinePlus className="fs-5 text-white" />
        </span>
      )}
    </div>
  );
};
export default StartNode;
